<router-outlet></router-outlet>
<div *ngIf="showLoader" class="k-i-loading"></div>

@if (isIdleTimeOutEnabled && showSessionExpiryPopup) {
  <div class="session-expiry-blocker">
    <div class="sessionExpiryPopup">
      <kendo-dialog (close)="saveModalAction()" [width]="420" [height]="'auto'">
        <kendo-dialog-titlebar>
          <img class="me-md-2" [src]="'assets/images/hourglass.svg'" />
          <p class="session-title">Session Expired</p>
        </kendo-dialog-titlebar>
        <div class="text-center divider-top"></div>
        <div class="customContent">
          <p class="session-message-login">Your session has timed out due to inactivity. Please log in again to resume your work.</p>
        </div>
        <div class="text-center divider-bottom"></div>
        <kendo-dialog-actions>
          <div class="cancel-btn">
            <button [className]="'btn-base btn-contained bw-font-prm-medium secondary-btn-contained btn-sm me-md-4 px-4'" (click)="onCancelClickForLogin()">Login Again</button>
          </div>
        </kendo-dialog-actions>
      </kendo-dialog>
    </div>
  </div>
} @else if (showSessionExpiryPopup) {
  <div class="col-md-8 mt-5 sessionExpiryPopupOld session-expiry-blocker">
    <kendo-dialog (close)="saveModalAction()" [width]="510" [height]="'auto'">
      <kendo-dialog-titlebar>
        <p [class]="'primary-fre-clr-bse'">Session Expired</p>
      </kendo-dialog-titlebar>
      <div class="pl-2 mb-3 customContent">
        <ng-content></ng-content>
        <p class="my-auto ml-2 bw-font-sec-bold text-start">Your session has expired. You will be redirected to the login screen.</p>
      </div>
    </kendo-dialog>
  </div>
}

@if (isIdleTimeOutEnabled && showSessionExpiringTimerPopup) {
  <div class="session-expiry-blocker">
    <div class="sessionExpiryPopup">
      <kendo-dialog (close)="saveModalAction()" [width]="420" [height]="'auto'">
        <kendo-dialog-titlebar>
          <img class="me-md-2" [src]="'assets/images/hourglass.svg'" />
          <p class="session-title">Session Expiring Soon</p>
        </kendo-dialog-titlebar>
        <div class="text-center divider-top"></div>
        <div class="customContent">
          <p class="session-message">
            Your session will expire in <b>{{ timeLeft }}</b> minute(s) due to inactivity
          </p>
        </div>
        <div class="text-center divider-bottom"></div>
        <kendo-dialog-actions>
          <div class="session-popup-action-btn">
            <div class="cancel-btn">
              <button [className]="'btn-base secondary-btn-text border-secondary bw-font-prm-medium btn-sm me-md-4 px-4 btn-sm me-md-4 px-4 session-logout-now-btn'" (click)="onCancelClick()">
                Logout Now
              </button>
            </div>
            <div class="cancel-btn">
              <button [className]="'btn-base btn-contained bw-font-prm-medium secondary-btn-contained btn-sm px-4'" (click)="stayLoggedInClick()">Stay Logged In</button>
            </div>
          </div>
        </kendo-dialog-actions>
      </kendo-dialog>
    </div>
  </div>
}

